import { mergeDigitalData, trackEvent } from "../../helpers/analytics";

let sectionByName = {
  "get-started": "Landing",
  "questions": "Step 1",
  "photo-upload": "Step 2",
  "shingle-color": "Step 3",
  "roofing-components": "Step 4",
  "contact": "Step 5",
  "request-sent": "Step 6"
}

const getLayerObject = (page_name) => {
  return {
    global: {
      pageName: `oc | widget | roofing | quote | ${page_name}`,
      pageSection: ["Widget", "Contractor Quoting Widget", `${sectionByName[page_name]}`]
    },
    page: {
      pageName: `oc | widget | roofing | quote | ${page_name}`
    }
  }
}

export const logGetStarted = () => {
  let updateObj = getLayerObject("get-started");
  mergeDigitalData(updateObj);
}

export const logRoofingQuestions = (args = {}) => {
  let trigger = args["trigger"];
  let updateObj = getLayerObject("questions");
  mergeDigitalData(updateObj);

  if (trigger == "prevButton") {
    trackEvent("screen-view", { step: "Step 1 - Questions", clickPath: "Previous Button" });
  } else {
    trackEvent("screen-view", { step: "Step 1 - Questions", clickPath: "Get Started Button" });
  }
}

export const logPhotoUpload = (args = {}) => {
  let trigger = args["trigger"];
  let updateObj = getLayerObject("photo-upload");
  mergeDigitalData(updateObj);

  if (trigger == "prevButton") {
    trackEvent("screen-view", { step: "Step 2 - Photo Upload", clickPath: "Previous Button" });
  } else {
    trackEvent("screen-view", { step: "Step 2 - Photo Upload", clickPath: "Next Button" });
  }
}

export const logShingleColor = (args = {}) => {
  let trigger = args["trigger"];
  let updateObj = getLayerObject("shingle-color");
  mergeDigitalData(updateObj);

  if (trigger == "prevButton") {
    trackEvent("screen-view", { step: "Step 3 - Shingle Color", clickPath: "Previous Button" });
  } else if (trigger == "skipLink") {
    trackEvent("screen-view", { step: "Step 3 - Shingle Color", clickPath: "Skip Photo Upload Link" });
  } else {
    trackEvent("screen-view", { step: "Step 3 - Shingle Color", clickPath: "Next Button" });
  }
}

export const logRoofingComponents = (args = {}) => {
  let trigger = args["trigger"];
  let pageData = args["pageData"];
  let updateObj = getLayerObject("roofing-components");
  mergeDigitalData(updateObj);

  if (trigger == "prevButton") {
    trackEvent("screen-view", { step: "Step 4 - Roofing Components", clickPath: "Previous Button" });
  } else {
    let shingleColor = pageData["shingle-color"] ? pageData["shingle-color"][0] : null;
    trackEvent("screen-view", { step: "Step 4 - Roofing Components", clickPath: "Next Button", shingleColor: shingleColor });
  }
}

export const logContactInfo = (args = {}) => {
  let updateObj = getLayerObject("contact");
  mergeDigitalData(updateObj);

  trackEvent("screen-view", { step: "Step 5 - Contact", clickPath: "Next Button" });
}

export const logRequestSent = (args = {}) => {
  let updateObj = getLayerObject("request-sent");
  mergeDigitalData(updateObj);

  trackEvent("screen-view", { step: "Step 6 - Request Sent", clickPath: "Next Button" });
}
